import { getGlobalAdminLink } from '../utils/getRedirectLink';

export const EXTERNAL_PATH = {
  GLOBAL_ADMIN_PANEL: process.env.REACT_APP_GLOBAL_ADMIN_PANEL_URL || getGlobalAdminLink(),
  ADMIN_PANEL: process.env.REACT_APP_ADMIN_PANEL_URL || '/admin/',
  MANAGER_PANEL: process.env.REACT_APP_MANAGER_PANEL_URL || '/manager-admin/',
  ADMIN_ACCOUNT: process.env.REACT_APP_ADMIN_ACCOUNT_URL || '/admin/my-account/',
};
